export const checkFieldIsNotApplicable = (name, notApplicable = []) =>
  notApplicable.includes(name);
